module.exports = __webpack_public_path__ + "img/teaching_4_zh.d0b427f8.png";